module.exports = __webpack_public_path__ + "static/media/edit_section_subsections_video.cfbb6f11.mov";